import React from 'react';

import { FeedIcon } from "UI/Feed";

export default function FeedItem({type, imageUrl, children})
{
    return <>
        <div className="relative">
            <FeedIcon type={type} imageUrl={imageUrl} />
        </div>

        <div className="min-w-0 flex-1">
            {children}
        </div>
    </>;
}